module.exports = __webpack_public_path__ + "static/media/CustomLanguage.ffaa191.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/CustomLanguage.mp4
// module id = mquG
// module chunks = 1